// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sliderClasses } from '@mui/material/Slider';
import { rem } from '../../tokens/conversions';
import { sliderColors } from './sliderColors';
export var Slider = function(mode) {
    var c = sliderColors(mode);
    var focusRing = "0px 0px 0px 4px ".concat(c.focus.border, "29");
    var _obj, _obj1;
    var override = {
        MuiSlider: {
            styleOverrides: {
                root: _define_property({
                    height: rem(4),
                    borderRadius: rem(2),
                    color: c.fill
                }, "&.".concat(sliderClasses.disabled), (_obj = {
                    color: c.disabled.fill
                }, _define_property(_obj, "& .".concat(sliderClasses.rail), {
                    backgroundColor: c.disabled.background
                }), _define_property(_obj, "& .".concat(sliderClasses.thumb), {
                    backgroundColor: c.disabled.fill,
                    boxShadow: 'none'
                }), _obj)),
                rail: {
                    backgroundColor: c.background,
                    opacity: 1
                },
                track: {
                    border: 'none'
                },
                thumb: (_obj1 = {
                    width: rem(16),
                    height: rem(16),
                    backgroundColor: c.handle,
                    border: "".concat(rem(2), " solid ").concat(c.handleBorder),
                    boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.4)',
                    '&::before': {
                        boxShadow: 'none'
                    }
                }, _define_property(_obj1, "&.".concat(sliderClasses.focusVisible), {
                    boxShadow: focusRing
                }), _define_property(_obj1, '&:hover', {
                    boxShadow: focusRing
                }), _obj1),
                thumbSizeSmall: {
                    width: rem(12),
                    height: rem(12)
                },
                mark: {
                    backgroundColor: c.dot,
                    width: rem(2),
                    height: rem(2),
                    borderRadius: rem(64)
                },
                markActive: {
                    backgroundColor: 'currentColor'
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Slider.js.map